export const BACKEND_VERSION_HEADER = 'x-server-version';
